// All Forms Action Script of Auth Pages

function useGoogleCredentials(response) {
  const credentialData = parseJwt(response.credential);
  const registrationForm = $('#registration-form');
  registrationForm.find('input[name="email"]').val(credentialData.email).prop('readonly', 'readonly');
  registrationForm.find('input[name="fname"]').val(credentialData.given_name);
  registrationForm.find('input[name="lname"]').val(credentialData.family_name);
  registrationForm.find('input[name="pwd"]').remove();
  registrationForm.find('input[name="pwd_conf"]').remove();
  registrationForm.find('input[name="google_token"]').val(response.credential);
  registrationForm.find('.social-register').hide();
}

$(function () {
  // get formatted array from serialized form data
  const parseFormData = function (data) {
    const updatedData = data.split('%40').join('@')
    const dataArray = updatedData.split('&')
    const resObj = dataArray.reduce((total, item) => {
      const kvs = item.split('=');
      let result = Object.assign({}, total);
      result[kvs[0]] = kvs[1];
      return result;
    }, {})

    return resObj
  }

  // get the result content of form action
  const getResultContent = function (type, flag, message) {
    var resultMessage = ''
    if (type === 'login') {
      resultMessage = flag ? i18next.t('auth.login-succeeded') : i18next.t('auth.wrong-username-or-password')
    } else if (type === 'register') {
      resultMessage = flag ? i18next.t('auth.email-sent-to-confirm-registration') : message
    } else if (type === 'invite') {
      resultMessage = flag ? i18next.t('auth.registration-succeeded') : message
    } else if (type === 'retrieve-password') {
      resultMessage = flag ?  i18next.t('auth.instructions-to-reset-password-have-been-sent') : message
    } else if (type === 'reset-password') {
      resultMessage = flag ? i18next.t('auth.succeeded-in-resetting-password') : message
    } else if (type === 'verify-email') {
      resultMessage = flag ? i18next.t('auth.verification-email-sent') : message
    }

    return flag ? `<div class="success"><div>${resultMessage}</div></div>` : `<div class="error"><div>${resultMessage}</div></div>`
  }

  // validate form data
  const validateFormData = function (type, data) {
    // ignore verify-email route
    if (type === 'verify-email') return true
    // to show first error
    const keys = Object.keys(data).reverse()
    var res = { status: 'ok', data: null }
    const optionalFields = ["google_token"];

    keys.map((k) => {
      var flag
      if (type === 'register' && k === 'email') {
        flag = validateEmail(data[k])
        if (!flag) {
          res.status = 'error'
          res.data = 'Invalid email format'
        }
      } else if ((type === 'register' || type === 'invite' || type === 'reset-password') && (k === 'password' || k === 'pwd')) {
        flag = checkPasswordComplexity(data[k])
        if (!flag) {
          res.status = 'error'
          res.data = i18next.t('auth.password-requirements')
        }
      } else if (k === 'pwd_conf') {
        flag = data[k] === data['pwd']

        if (!flag) {
          res.status = 'error'
          res.data = i18next.t('auth.confirm-password-not-match')
        }
      } else if (k === 'phone') {
        flag = validatePhone(data[k])
        if (!flag) {
          res.status = 'error'
          res.data = i18next.t('auth.invalid-phone-number-format')
        }
      } else {
        flag = data[k].length
        if (!flag && !optionalFields.includes(k)) {
          res.status = 'error'
          res.data = 'Should fill required fields'
        }
      }
    })

    res.data = `<div class="error"><div>${res.data}</div></div>`

    return res
  }

  // handle success action of form
  const handleRedirect = function (type, dom) {
    if (type === 'login' || type === 'invite') {
      location.href = '/'
    } else if (type === 'register' || type === 'retrieve-password' || type === 'verify-email') {
      showTimerStatus(dom, 3, () => {
        location.href = '/users/logout'
      })
      showSlideMsg(i18next.t('auth.it-will-be-redirected-automatically'))
    } else if (type === 'reset-password') {
      showTimerStatus(dom, 3, () => {
        location.href = '/users/login'
      })
      showSlideMsg(i18next.t('auth.it-will-be-redirected-to-login-automatically'))
    }
  }

  $('body.auth form').on('change', '[name="lang"]', function() {
    const locale = $(this).val();
    i18next.changeLanguage(locale).then(t => {
      setCookie('locale', locale, 10*365);

      var placeholderTranslatables = $('body.auth').find('select[data-i18n-placeholder], input[data-i18n-placeholder], a[data-i18n-placeholder], button[data-i18n-placeholder]');
      placeholderTranslatables.each((index, el) => {
        el = $(el);
        if (el.data('i18n-placeholder')) {
          el.prop('placeholder', t(el.data('i18n-placeholder')));
        }
      });

      var translatables = $('body.auth').find('select[data-i18n], input[data-i18n], a[data-i18n], button[data-i18n], h1[data-i18n]');
      translatables.each((index, el) => {
        el = $(el);
        if (el.data('i18n')) {
          el.html(t(el.data('i18n')));
        }
      });
    })
  });

  // control all auth form submit actions
  $('body.auth form').submit(function (e) {
    // alert('Handler for .submit() called.')
    e.preventDefault()

    const form = $(this)
    const submitBtn = form.find('[type="submit"]')
    const type = form.attr('type')
    const msg = form.closest('.bg-box').find('.msg')

    const apiUrl = form.attr('action')
    const data = form.serialize()

    const resValidate = validateFormData(type, parseFormData(data))

    if (resValidate.status === 'error') {
      msg.html(resValidate.data)
      return
    }

    const handleSuccess = (res) => {
      const isSuccess = res.status === 'ok'
      const content = getResultContent(type, isSuccess, res.data)
      msg.html(content)
      handleLoadingStatus(submitBtn, false)

      // console.log('isSuccess', isSuccess)
      if (isSuccess) {
        form.find('input').val('')
        handleRedirect(type, submitBtn)
      }
    }

    const handleError = () => {
      handleLoadingStatus(submitBtn, false)
      //showError()
    }

    msg.html('')

    // show loading icon until action is finished
    handleLoadingStatus(submitBtn, true)

    // do api call
    doAjaxPost(apiUrl, data, handleSuccess, handleError)
  })

  $('#accept').click(function () {
    const submitBtn = $(this)
    const data = { acceptance: $('#acceptance').is(':checked') }

    if (!data.acceptance) {
      // console.log("don't accept the gdpr yet")
      return
    }

    const apiUrl = '/users/gdpr'
    const handleSuccess = (res) => {
      handleLoadingStatus(submitBtn, false)
      // console.log('isSuccess', res.status)
      if (res.status === 'ok') {
        location.href = '/'
      } else {
        handleLoadingStatus(submitBtn, false)
        // console.log('error', res.data)
      }
    }
    const handleError = () => {
      handleLoadingStatus(submitBtn, false)
      // console.log('there is an error in processing gdpr acceptance')
      //showError()
    }

    handleLoadingStatus(submitBtn, true)

    doAjaxPost(apiUrl, data, handleSuccess, handleError)
  })

  $('#decline').click(function () {
    window.localStorage.clear()
    location.href = '/'
  })

  $('#acceptance').click(function () {
    const parent = $(this).closest('.footer-wrapper')
    if ($(this).is(':checked')) {
      parent.find('#accept').removeAttr('disabled')
      parent.find('#decline').removeAttr('disabled')
    } else {
      parent.find('#accept').attr('disabled', true)
      parent.find('3decline').attr('disabled', true)
    }
  })

  $('span.fa-eye').click(function () {
    const passwordDom = $(this).parent().find('input')
    const type = passwordDom.attr('type')
    const newType = type === 'text' ? 'password' : 'text'
    // console.log('newType', type, newType)
    passwordDom.attr('type', newType)
  })

  doAjaxPost(`/users/log-connection`, {});

  function setCookie(cookieName, cookieValue, expirationDays) {
    var d = new Date();
    d.setTime(d.getTime() + (expirationDays*24*60*60*1000));
    var expires = "maxAge="+ d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }
})
